import React from 'react';

interface HeroSectionProps {
  onDonateClick: (e: React.MouseEvent) => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onDonateClick }) => {
  return (
    <section 
      id="hero" 
      className="gm-about-section"
      style={{
        backgroundImage: 'url(/images/IMGL9269-min-scaled.jpg)'
      }}
    >
      <div className="gm-hero-inner">
        <div className="gm-hero-content">
          <h2>
            MAKE A LIFESAVING CONTRIBUTION
          </h2>
          
          <h3>
            Eliminating malaria means investing in heathier and more prosperous societies. Eliminating malaria contributes to ending poverty, improving health, and ensuring quality education. Eliminating malaria will save lives and unlock human potential.
          </h3>
          
          <a 
            href="#donate" 
            onClick={onDonateClick}
            className="gm-hero-link"
          >
            Give Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
